import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import {
  Grid,
  Typography,
  Box,
  Stack,
  Breadcrumbs,
  Link,
  useMediaQuery
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CustomDivider from './CustomDivider';
import Coriolis from '../images/Coriolis_Logo.jpg';

function Academie({ t }) {
  const isMobile = useMediaQuery('(max-width: 600px)');

  const breadcrumbs = [
    <Link
      key="1"
      underline="hover"
      color="inherit"
      component={RouterLink}
      to="/Services"
    >
      {t('Breadcrumbs.service')}
    </Link>,
    <Typography
      key="2"
      color="text.primary"
      sx={{ color: '#AB0C18' }}
    >
      {t('Breadcrumbs.academie')}
    </Typography>
  ];

  return (
    <Box
      sx={{
        width: '100%',
        overflowX: 'hidden',
        overflowY: 'auto'
      }}
    >
      <Grid
        container
        direction="column"
        alignItems="center"
        sx={{ py: isMobile ? 3 : 6 }}
      >
        <Box
          sx={{
            width: 'calc(100% - 32px)',
            paddingBottom: isMobile ? '30px' : '0',
            maxWidth: '900px'
          }}
        >
          {/* Title */}
          <Typography
            variant="h6"
            sx={{ fontWeight: 'bold', color: '#AB0C18', mb: 2 }}
          >
            {t('Academie.titre')}
          </Typography>

          <CustomDivider sx={{ mb: 3 }} />

          {/* Breadcrumbs */}
          <Stack spacing={2} sx={{ mb: 4 }}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" sx={{ color: '#AB0C18' }} />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </Stack>

          {/* Logo + Description */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 4
            }}
          >
            <img
              src={Coriolis}
              alt="Coriolis Logo"
              style={{
                marginRight: '15px',
                width: isMobile ? '50px' : '100px',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
            <Typography>{t('Academie.description')}</Typography>
          </Box>

          {/* Section 1 */}
          <Typography
            variant="h5"
            sx={{ mb: 1, color: '#AB0C18', fontSize: isMobile ? '18px' : '20px' }}
          >
            {t('Academie.sous-titre1.titre')}
          </Typography>
          <Typography sx={{ mb: 2, fontSize: isMobile ? '14px' : '16px' }}>
            {t('Academie.sous-titre1.description1')}
          </Typography>
          <Typography sx={{ mb: 4, fontSize: isMobile ? '14px' : '16px' }}>
            {t('Academie.sous-titre1.description2')}
          </Typography>

          {/* Section 2 */}
          <Typography
            variant="h5"
            sx={{ mb: 1, color: '#AB0C18', fontSize: isMobile ? '18px' : '20px' }}
          >
            {t('Academie.sous-titre2.titre')}
          </Typography>
          <Typography sx={{ mb: 2, fontSize: isMobile ? '14px' : '16px' }}>
            {t('Academie.sous-titre2.description')}
          </Typography>
        </Box>
      </Grid>
    </Box>
  );
}

export default withTranslation()(Academie);
